// we use these values for API calls
export enum PaymentMethodsEnum {
  CREDIT_CARD = 'CREDITCARD',
  APPLE_PAY = 'APPLEPAY',
  PAYPAL = 'PAYPAL',
  ECHECK = 'ECHECK',
  AMAZON_PAY = 'AMAZONPAY',
}

export enum BillingStrategy {
  Stripe = 'stripe',
  InHouse = 'in-house',
}

export type BillingStrategyQuery =
  | {
      data: null;
      isPending: true;
    }
  | {
      data: BillingStrategy;
      isPending: false;
    };

export const createResolvedBillingStrategy = (data: BillingStrategy): BillingStrategyQuery => ({
  data,
  isPending: false,
});

export const isStripeBillingStrategy = (
  billingStrategy: BillingStrategyQuery
): billingStrategy is { data: BillingStrategy.Stripe; isPending: false } =>
  !billingStrategy.isPending && billingStrategy.data === BillingStrategy.Stripe;
